/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import OrdersDashboard from '../../Components/OrdersDashboard/OrdersDashboard.component';
import BasePage from '../../Components/Page/BasePage.component';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import './Orders.page.i18n';
import OrdersPagePropTypes from './Orders.page.props';
import OrdersPageSidebar from './Orders.page.sidebar';
import ordersPageStyles from './Orders.page.styles';

/**
 * OrdersPageComponent
 * @export
 * @class OrdersPageComponent
 * @extends {React.Component<OrdersPageComponentComposedProps, OrdersPageComponentState>}
 */
export class OrdersPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<OrdersPageComponentProps>}
   * @memberof OrdersPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrdersPage`}
   * @memberof OrdersPageComponent
   */
  static displayName = `OrdersPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrdersPageComponent
   */
  static propTypes = OrdersPagePropTypes;

  /**
   * Data specific to the `<OrdersPage />` instance
   * @type {OrdersPageComponentState}
   * @memberof OrdersPageComponent
   */
  state = {};

  /**
   * When the Component mounts, retrieve user accounts
   * @returns {void} void
   * @memberof OrdersPageComponent
   */
  async componentDidMount() {
    const { services } = this.props;
    const accounts = await services.userService.getUserAccounts();
    this.setState(accounts);
    return;
  }

  /**
   * Open the refine menu
   * @returns {void} void
   * @memberof OrdersPageComponent
   */
  handleRefineToggle = () => {
    const { actions } = this.props;
    actions.sidebarRightToggle();
    return;
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrdersPage />`
   * @memberof OrdersPageComponent
   */
  render() {
    const { classes, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    return (
      <BasePage
        className={classes.root}
        heading="OrdersPage.PageTitle"
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        hideUserMenu
        sidebarContent={<OrdersPageSidebar />}
        title="OrdersPage.PageTitle"
      >
      <Typography variant="body1" style={{ margin: '16px 16px', textAlign: 'center', backgroundColor: '#f1f8e9', padding: '8px 16px', borderRadius: 4 }}>
        <span style={{ color: '#388e3c', fontWeight: 600 }}>
          Important Pricing Update:
        </span>{' '}
        Effective <span style={{ fontWeight: 600 }}>4 May 2026</span>, a Production
        and Transport Surcharge of <span style={{ fontWeight: 600 }}>$10.06 ex GST per m³</span>{' '}
        will apply, due to the recent escalation in global energy and commodity markets which is significantly impacting production and supply chain costs.
      </Typography>
        <OrdersDashboard heading="OrdersPage.PageTitle" padding="none" />
      </BasePage>
    );
  }
}

/** @type {React.ComponentClass<OrdersPageComponentProps>} */
const OrdersPage = compose(
  withEntries,
  withRouter,
  withServices,
  withWidth(),
  withStyles(themeCreateInjectableStyles(ordersPageStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...sidebarActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrdersPageComponent);

export default OrdersPage;
